module.exports = __webpack_public_path__ + "img/Animales-DCU30-50.ce1cb72a.png";